export default __webpack_public_path__ + "static/day-12-568355b6bc9f85eecd6a8b4e881e82c4.gif";